import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import type { FlowConfig } from '@swf/core/types/Wizard';
import { Action } from '@swf/core/types/Wizard';

import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFCitizenship from '../components/RMFCitizenship/RMFCitizenship';
import RMFCompleted from '../components/RMFCompleted/RMFCompleted';
import RMFStandaloneFinalPage from '../components/RMFStandaloneFinalPage/RMFStandaloneFinalPage';
import RMFVerification from '../components/RMFVerification/RMFVerification';

import useRMFBaseSteps from './useRMFBaseSteps';
import { Guard } from './useRmfGuards';
import { Service } from './useRmfServices';

const useRmfROFlow = (): FlowConfig => {
  const exitWizard = useWizardExit();

  const jumpToFeatureStep = {
    name: 'jumpToFeatureStep',
    entry: Action.GoJump
  };
  const { invokeLegalNameSave, invokeSignupDob, forkSignupDepositCheckDone, forkDobCheck } =
    useRMFBaseSteps();

  const forkJumpToFeature = new Fork(
    Guard.DoesJumpToFeatureStep,
    [new Invoke(Service.SetJumpCreator, jumpToFeatureStep)],
    [forkSignupDepositCheckDone, RMFVerification]
  );

  const forkRmfExit = new Fork(
    Guard.StandaloneRmf,
    [
      RMFStandaloneFinalPage,
      {
        name: 'exitRMF',
        entry: exitWizard,
        type: 'final'
      }
    ],
    [forkJumpToFeature]
  );

  const forkStandaloneRMFCheck = new Fork(Guard.HideRMFCompletion, [forkRmfExit], RMFCompleted);

  const invokeEnableRealMoneyFlag = new Invoke(
    Service.RmfEnableRealMoneyFlag,
    forkStandaloneRMFCheck
  );
  const invokeCitizenshipSave = new Invoke(
    Service.RmfCitizenshipSave,
    invokeEnableRealMoneyFlag,
    RMFCitizenship
  );
  const forkShowCitizenship = new Fork(
    Guard.ShowCitizenship,
    [RMFCitizenship, invokeCitizenshipSave],
    [invokeEnableRealMoneyFlag]
  );

  const invokeAddressSave = new Invoke(Service.RmfAddressSave, forkShowCitizenship, RMFAddress);

  return [
    invokeSignupDob,
    forkDobCheck,
    invokeLegalNameSave,
    RMFAddress,
    invokeAddressSave,
    forkShowCitizenship,
    forkStandaloneRMFCheck,
    RMFCompleted,
    forkJumpToFeature,
    jumpToFeatureStep
  ];
};

export default useRmfROFlow;
